import React, { useEffect } from "react";
import { Chart } from "chart.js/auto";
import "./InvoiceStatusChart.scss";
import { IInvoiceStatusChartData } from "../../models/Dasboard";

interface InvoiceStatusChartProps {
  invoiceStatuses: IInvoiceStatusChartData;
}

const InvoiceStatusChart: React.FC<InvoiceStatusChartProps> = ({
  invoiceStatuses,
}) => {
  useEffect(() => {
    renderInvoiceStatusChart(invoiceStatuses.chart, invoiceStatuses.months);
  }, []);

  const renderInvoiceStatusChart = async (
    data: { [key: string]: number[] },
    months: string[]
  ) => {
    await clearInvoiceStatusChart();

    const canvas = document.getElementById(
      "invoice-status-graph"
    ) as HTMLCanvasElement;

    if (!canvas) return;

    const ctx = canvas.getContext("2d");
    if (!ctx) return;

    canvas.setAttribute("height", `${10 * 18 + 10}px`);

    const allValues = Object.values(data).flat();
    const maxValue = Math.max(...allValues, 0);
    const roundedMax = Math.ceil(maxValue / 50000) * 50000;
    const stepSize = roundedMax / 4;

    const colors: { [key: string]: string } = {
      Due: "#FEC400",
      Overdue: "#4D4DFF",
    };

    new Chart(ctx, {
      type: "bar",
      data: {
        labels: months,
        datasets: Object.keys(data).map((label) => {
          const titleCaseLabel =
            label.charAt(0).toUpperCase() + label.slice(1).toLowerCase();

          return {
            label: titleCaseLabel,
            data: data[label],
            backgroundColor: colors[titleCaseLabel] || "#ccc",
            barThickness: 12,
            borderRadius: 10,
          };
        }),
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: {
            display: true,
            position: "bottom",
            labels: {
              boxWidth: 12,
              color: "#333",
              font: {
                size: 12,
                weight: 500,
                family: "Inter",
              },
            },
          },
        },
        scales: {
          y: {
            stacked: true,
            min: 0,
            max: roundedMax,
            ticks: {
              stepSize,
              color: "#9CA3AF",
              font: {
                size: 12,
                weight: 500,
                family: "Inter",
              },
              callback: (value: string | number) => {
                if (typeof value === "number") {
                  return value.toLocaleString("en-IN");
                }
                return value;
              },
            },
            grid: {
              display: true,
              color: "#E5E7EB",
            },
            border: {
              display: false,
            },
          },
          x: {
            stacked: true,
            grid: {
              display: false,
            },
            ticks: {
              color: "#333333",
              font: {
                size: 12,
                weight: 500,
                family: "Inter",
              },
            },
          },
        },
      },
    });
  };

  const clearInvoiceStatusChart = async () => {
    const chartStatus = Chart.getChart("invoice-status-graph");
    if (chartStatus !== undefined) {
      chartStatus.destroy();
    }
  };

  return (
    <div className="invoice-status-main-chart-container py-12 px-8 flex-column gap-16">
      <p className="xetgo-font-tag bold heading">Invoice Status</p>
      <div>
        <canvas id="invoice-status-graph"></canvas>
      </div>
    </div>
  );
};

export default InvoiceStatusChart;
